module.exports = __webpack_public_path__ + "img/IMG_5903.04b6a9ff.jpg";